"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getSubmissionPath = void 0;
const fetch_type_enum_1 = require("@App/kit/components/WorkItemV2/fetch-type-enum");
const navigation_1 = __importDefault(require("@App/navigation"));
const getSubmissionPath = (rightsholderId, workId, fetchType) => workId
    ? fetchType === fetch_type_enum_1.FetchType.MLC
        ? navigation_1.default.rightholder.registrationHistory.submission(rightsholderId, workId)
        : navigation_1.default.rightholder.registrationHistory.transaction(rightsholderId, workId)
    : '';
exports.getSubmissionPath = getSubmissionPath;
